export enum IvaExemptTypeEnum {
    yes = "yes",
    no = "no"
}


export class IvaExemptType {
    constructor(
        public readonly id: IvaExemptTypeEnum,
        public readonly label: string,
    ) { }
}